module.exports = __webpack_public_path__ + "static/media/pic2.19a3c4fb.jpg";